import { setupWorker, RestHandler, MockedRequest, DefaultBodyType } from 'msw';

const handlers: RestHandler<MockedRequest<DefaultBodyType>>[] =
    require(`./mocks/${process.env.REACT_APP_MOCK_REQUESTS}.ts`).default;

export const worker = setupWorker(...handlers);
